import { useEffect } from "react";
import { useSettingsStore } from "@/stores/SettingsStore";

/**
 * Hook that applies the user's theme preference to the HTML root element.
 * This toggles the 'dark' class on the document element which Tailwind uses
 * for dark mode styling (darkMode: 'class' strategy).
 *
 * - dark: Applies dark theme (default)
 * - light: Applies light theme
 */
export function useTheme() {
  const theme = useSettingsStore((state) => state.theme);

  useEffect(() => {
    const htmlElement = document.documentElement;

    if (theme === "dark") {
      htmlElement.classList.add("dark");
    } else {
      htmlElement.classList.remove("dark");
    }

    // Also set a data attribute for any CSS that might need it
    htmlElement.setAttribute("data-theme", theme);
  }, [theme]);

  return theme;
}
